import { useNav } from "../../context/contextNav";

const useReports = () => {
  const { 
    setActiveNav,
    setOpenCloudSubMenu,
    setOpenComplianceSubMenu,
    setReportTab,
    setReportSubTab,
  } = useNav();

  const webReportNav = () => {
    setActiveNav(8);
    setOpenCloudSubMenu(false);
    setOpenComplianceSubMenu(false);
    setReportTab("Web Reports");
    setReportSubTab("");
  };

  const networkReportNav = () => {
    setActiveNav(8);
    setOpenCloudSubMenu(false);
    setOpenComplianceSubMenu(false);
    setReportTab("Network Reports");
    setReportSubTab("");
  };

  const awsConfigReportNav = () => {
    setActiveNav(8);
    setOpenCloudSubMenu(false);
    setOpenComplianceSubMenu(false);
    setReportTab("AWS Reports");
    setReportSubTab("AWS Config");
  };

  const awsEc2ReportNav = () => {
    setActiveNav(8);
    setOpenCloudSubMenu(false);
    setOpenComplianceSubMenu(false);
    setReportTab("AWS Reports");
    setReportSubTab("AWS EC2");
  };

  const awsS3ReportNav = () => {
    setActiveNav(8);
    setOpenCloudSubMenu(false);
    setOpenComplianceSubMenu(false);
    setReportTab("AWS Reports");
    setReportSubTab("AWS S3");
  };

  const azureConfigReportNav = () => {
    setActiveNav(8);
    setOpenCloudSubMenu(false);
    setOpenComplianceSubMenu(false);
    setReportTab("Azure Reports");
    setReportSubTab("Azure Config");
  };

  const azureVmsReportNav = () => {
    setActiveNav(8);
    setOpenCloudSubMenu(false);
    setOpenComplianceSubMenu(false);
    setReportTab("Azure Reports");
    setReportSubTab("Azure VM");
  };

  const azureBlobReportNav = () => {
    setActiveNav(8);
    setOpenCloudSubMenu(false);
    setOpenComplianceSubMenu(false);
    setReportTab("Azure Reports");
    setReportSubTab("Azure Blob");
  };

  const gcpConfigReportNav = () => {
    setActiveNav(8);
    setOpenCloudSubMenu(false);
    setOpenComplianceSubMenu(false);
    setReportTab("GCP Reports");
    setReportSubTab("GCP Config");
  };

  const gcpGceReportNav = () => {
    setActiveNav(8);
    setOpenCloudSubMenu(false);
    setOpenComplianceSubMenu(false);
    setReportTab("GCP Reports");
    setReportSubTab("GCP GCE");
  };

  const gcpGcsReportNav = () => {
    setActiveNav(8);
    setOpenCloudSubMenu(false);
    setOpenComplianceSubMenu(false);
    setReportTab("GCP Reports");
    setReportSubTab("GCP GCS");
  };

  return {
    webReportNav,
    networkReportNav,

    awsConfigReportNav,
    awsEc2ReportNav,
    awsS3ReportNav,

    azureConfigReportNav,
    azureVmsReportNav,
    azureBlobReportNav,

    gcpConfigReportNav,
    gcpGceReportNav,
    gcpGcsReportNav,
  };
};

export default useReports;
